export const defaultTemplate = {
  main: {
    background: "#eee",
    backgroundSize: "cover",
    backgroundUrl: "",
    backgroundAttachment: 'fixed',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    videoBackgroundEnabled: false,
    youtubeUrl: '',
    backgroundColor: '#fff'

  },
  content: {
    backgroundColor: "#ffffff",
    maxWidth: "100%",
    marginTop: "0px",
    marginBottom: "0px",
    borderRadius: "0px",
    boxShadow: 'none',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '13px',
    minHeight: '100%'
  },
  table: {
    borderCollapse: 'collapse',
    border: '0px'
  },
  tcell: {
    padding: '8px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#dddddd',
    fontFamily: 'Open Sans',
    fontSize: '15px',
    backgroundColor: '#fff',
    color: '#222',
    fontWeight: 'normal'
  },
  spinner: {
    color: '#17a2b8'
  },
  thead: {
    padding: '8px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#dddddd',
    fontFamily: 'Open Sans',
    fontSize: '15px',
    backgroundColor: '#fff',
    color: '#222',
    fontWeight: 'normal'
  },
  text: {
    color: "#170c53",
    fontFamily: "Open Sans",
    fontWeight: "normal",
    letterSpacing: "0px",
    fontSize: "16px"
  },
  title: {
    color: "#535e58",
    fontFamily: "Open Sans",
    fontSize: "20px",
    fontWeight: "bold",
    letterSpacing: "1px"
  },
  a: {
    color: "blue",
    textDecoration: "none",
    fontFamily: "Open Sans",
    letterSpacing: 'unset',
    fontWeight: 'unset',
    fontSize: 'unset',
    "&:hover": {
      color: 'lightblue',
      textDecoration: 'none'
    }
  },
  button: {
    height: "auto",
    minHeight: '30px',
    width: "100%",
    borderRadius: "0px",
    color: "white",
    fontSize: "20px",
    padding: '5px 20px',
    fontWeight: 'unset',
    backgroundColor: "#FF8282",
    borderColor: 'transparent',
    "&:hover": {
      color: "white",
      backgroundColor: "pink"
    },
    boxShadow: 'none',
    fontFamily: 'Open Sans',
    textTransform: 'unset'
  },
  header: {
    backgroundColor: "#222",
    marginTop: "0px",
    marginBottom: "0px",
    content: [],
    height: 'auto',
    background: '#222',
    width: '100%',
    innerWidth: '50%',
    overflow: 'hidden',
    boxShadow: 'none',
    backgroundUrl: "",
    padding: 'unset',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  footer: {
    backgroundColor: "#222",
    marginTop: "0px",
    marginBottom: "0px",
    content: [],
    height: 'auto',
    background: '#222',
    width: '100%',
    overflow: 'visible',
    backgroundUrl: "",
    innerWidth: '50%',
    boxShadow: 'none',
    padding: 'unset',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  label: {
    color: "#535e58",
    fontFamily: "Open Sans",
    fontSize: "16px",
    fontWeight: "unset",
    letterSpacing: "1px"
  },
  menu: {
    backgroundColor: "unset",
    fontFamily: "Open Sans",
    fontSize: "20px",
    fontWeight: "normal",
    color: "unset",
    textDecoration: "none",
    justifyContent: "left",
    display: 'none',
    position: 'unset',
    padding: 'unset',
    innerWidth: '50%',
    marginLeft: 'auto',
    marginRight: 'auto',
    minHeight: '50px',
    width: '100%',
    height: 'auto',
    "&:active": {
      color: 'unset',
      backgroundColor: 'unset'
    }
  },
  input: {
    readOnlyOpacity: 0.8,
    fontSize: "17px",
    fontWeight: "normal",
    color: "#686673",
    backgroundColor: "#ffffff",
    borderColor: "#c0bcc2",
    margin: "0px",
    borderRadius: "10px",
    width: "150px",
    boxShadow: 'none',
    textAreaMinHeight: '200px',
    fontFamily: 'Open Sans'
  },
  subtitle: {
    color: "#7ed321",
    fontSize: "15px",
    fontFamily: "Open Sans",
    letterSpacing: "0px",
    fontWeight: "unset",
  },
  interaction: {
    exhibitor:{
      frame: {
        background: 'unset',
        borderRadius: 'unset',
        padding: 'unset',
        
      },
      logo: {
        background: 'unset'
      },
      title: {
        color: 'unset',
        fontSize: 'unset',
        fontWeight: 'unset',
        fontFamily: 'unset'
      },
      subtitle: {
        color: 'unset',
        fontSize: 'unset',
        fontWeight: 'unset',
        fontFamily: 'unset'
      }
    },
    chat: {
      primaryColor: 'unset',
      badgePillColor: 'unset',
      secondaryColor: 'unset',
      sendButtonColor: 'unset',
      container: {
        borderColor: 'unset',
        borderRadius: 'unset',
        borderWidth: 'unset',
      },
      header: {
        background: 'unset',
        borderColor: 'unset',
        color: 'unset',
        fontWeight: 'unset',
        fontFamily: 'unset',
        fontSize: 'unset',
      },
      footer: {
        background: 'unset',
        borderColor: 'unset',
        inputColor: 'unset',
        inputBackground: 'unset',
        fontFamily: 'unset'
      },
      content: {
        background: 'unset'
      },
      messages: {
        fontSize: 'unset',
        fontWeight: 'unset',
        lineHeight: 'unset',
        fontFamily: 'unset',
        color: 'unset',
      
        receiver: {
          backgroundColor: 'unset',
          color: 'unset',
          thumbColor: 'unset',
        },
        sender: {
          backgroundColor: 'unset',
          color: 'unset',
          thumbColor: 'unset',
        }
      }
   

    },
    client: {
      sendButton: {
        height: "auto",
        width: "auto",
        borderRadius: "0px",
        color: "white",
        fontSize: "20px",
        backgroundColor: "#FF8282",
        /*   background: 'linear-gradient(to right, #dddddd2b, #b1b1b170)', */
        boxShadow: 'none',
        fontFamily: 'Open Sans',

      },
      optionButton: {
        height: 'unset'
      },
      question: {
        minWidth: 'unset',
        maxWidth: 'unset'
      },
      frame: {
        backgroundColor: 'unset',
        borderRadius: 'unset',
        borderColor: 'unset',
        fontFamily: 'unset',
        fontWeight: 'unset',
        color: 'unset',
        fontSize: 'unset',

      }
    },
    agenda: {
      content: {
        padding: 'unset',
        background: 'unset',
        backgroundColor: 'unset',
        backgroundUrl: 'unset',
        margin: 'unset',
        borderRadius: 'unset'
      },
      title: {
        fontSize: 'unset',
        fontWeight: 'unset',
        fontFamily: 'unset',
        color: 'unset',
        marginLeft: 'unset',
      },
      row: {
        default: {
          frame: {
            borderColor: 'unset',
            borderWidth: 'unset',
            backgroundColor: 'unset',
            padding: 'unset',
            borderRadius: 'unset',
       /*      margin: 'unset', */
            marginTop: 'unset',
          },
          title: {
            fontSize: 'unset',
            color: 'unset',
            fontWeight: 'unset',
            fontFamily: 'unset'
          },
          text: {
            fontSize: 'unset',
            color: 'unset',
            fontWeight: 'unset',
            fontFamily: 'unset'
          }
        },
        active: {
          frame: {
            borderColor: 'unset',
            borderWidth: 'unset',
            backgroundColor: 'unset',
            padding: 'unset',
            borderRadius: 'unset',
      /*       margin: 'unset', */
            marginTop: 'unset',
          },
          title: {
            fontSize: 'unset',
            color: 'unset',
            fontWeight: 'unset',
            fontFamily: 'unset'
          },
          text: {
            fontSize: 'unset',
            color: 'unset',
            fontWeight: 'unset',
            fontFamily: 'unset'
          }
        },
        passed: {
          frame: {
            borderColor: 'unset',
            borderWidth: 'unset',
            backgroundColor: 'unset',
            padding: 'unset',
            borderRadius: 'unset',
         /*    margin: 'unset', */
            marginTop: 'unset',
          },
          title: {
            fontSize: 'unset',
            color: 'unset',
            fontWeight: 'unset',
            fontFamily: 'unset'
          },
          text: {
            fontSize: 'unset',
            color: 'unset',
            fontWeight: 'unset',
            fontFamily: 'unset'
          }
        }
      }

    },
    connections: {
      background: 'unset',
      backgroundColor: 'unset',
      backgroundUrl: 'unset',
      borderRadius: 'unset',
      fontSize: 'unset',
      fontWeight: 'unset',
      fontFamily: 'unset',
      borderWidth: 'unset',
      borderColor: 'unset',
      color: 'unset'
    }
  },
  chart: {
    colors: {
      color1: 'blue',
      color2: 'red',
      color3: 'orange',
      color4: 'green',
      color5: 'yellow'
    },
    textflowColor: 'black',
    textflowBgColor: 'lightgray'

  },
  scrollbar: {
    thumbBackgroundColor: 'unset',
    thumbBorderRadius: 'unset',
    trackBackgroundColor: 'unset',
    thumbColorHover: 'unset',
    width: 'unset'
  },

  responsive: {
    tablet: {
      content: {
        maxWidth: '100%',
        minHeight: '100%',
        marginTop: "unset",
        marginBottom: "unset",
        borderRadius: "unset",
        boxShadow: 'unset',
        marginLeft: 'unset',
        marginRight: 'unset',
        padding: 'unset'
      },
      menu: {
        display: 'unset',
        padding: 'unset',
        innerWidth: 'unset',
        minHeight: 'unset',
        width: '100%',
        position: 'fixed'
      },
      footer: {
        height: 'unset',
        width: '100%',
        padding: 'unset'
      },
      header: {
        height: 'unset',
        width: '100%',
        padding: 'unset',
        innerWidth: 'unset',
      }
    },
    smartphone: {
      content: {
        maxWidth: '100%',
        marginTop: "unset",
        minHeight: '100%',
        marginBottom: "unset",
        borderRadius: "unset",
        boxShadow: 'unset',
        marginLeft: 'unset',
        marginRight: 'unset',
        padding: '15px'
      },
      menu: {
        display: 'unset',
        position: 'unset',
        padding: 'unset',
        innerWidth: 'unset',
        minHeight: 'unset',
        width: '100%',
      },
      footer: {
        height: 'unset',
        width: '100%',
        padding: 'unset',
        innerWidth: '50%',
      },
      header: {
        height: 'unset',
        width: '100%',
        padding: 'unset',
        innerWidth: 'unset',
      }
    }
  }
};




/*
export const defaultTemplate = {
  main: {
    background: "orange",
    backgroundUrl: "",
    backgroundColor: "#fff",
    backgroundSize: "cover"
  },
  backgroundConfig: {
    backgroundColor: "",
    maxWidth: "",
    marginTop: "",
    marginBottom: ""
  },
  text: {
    color: "#fff",
    fontFamily: "",
    fontWeight: "",
    fontSpacing: ""
  },
  title: {
    color: "",
    fontFamily: "",
    fontSize: "",
    fontWeight: "",
    fontSpacing: ""
  },
  subTitle: {
    color: "",
    fontFamily: "",
    fontSize: "",
    fontWeight: "",
    fontSpacing: ""
  },
  a: {
    colorDarkBg: "",
    colorLightBg: "",
    underScore: false,
    "&:hover": {
      color: ""
    }
  },
  button: {
    size: "",
    borderRadius: "",
    color: "",
    backgroundColor: "",
    "&:hover": {
      color: "",
      backgroundColor: "red"
    }
  },
  header: {
    backgroundColor: "",
    marginTop: "",
    marginBottom: "",
    content: "",
    height: 'auto',
    background: '',
    width: '100%',
    overflow: 'visible'
  },
  footer: {
    backgroundColor: "",
    marginTop: "20%",
    marginBottom: "0px",
    content: "",
    height: 'auto',
    background: '',
    width: '100%',
    overflow: 'visible'
  },
  menu: {
    icon: "",
    backgroundColor: "",
    fontFamily: "",
    fontSize: "",
    fontWeight: "",
    color: "",
    underScore: false,
    activePageColor: "",
    activePageBackgroundColor: "",
    justify: ""
  },
  input: {
    fontFamily: "",
    fontSize: "",
    fontWeight: "",
    color: "",
    backgroundColor: "",
    borderColor: "",
    margin: "",
    borderRadius: ""
  }
};


 */




